<template>
    <cadastro-simples-form
        endpoint="almox-fornecedor"
        rota-base="/admin/almox-fornecedor"
        titulo-singular="Fornecedor"
        :campos-extras="camposExtras">
    </cadastro-simples-form>
</template>
<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default {
    components: { CadastroSimplesForm },
    data: () => ({
        // `nome` (do componente base) é o nome fantasia.
        camposExtras: [
            { campo: 'razao_social', label: 'Razão Social', tipo: 'string', maxLength: 200, span: 12 },
            { campo: 'cnpj_cpf', label: 'CNPJ / CPF', tipo: 'string', maxLength: 30, span: 6 },
            { campo: 'inscricao_estadual', label: 'Inscrição Estadual', tipo: 'string', maxLength: 30, span: 6 },
            { campo: 'tipo', label: 'Tipo', tipo: 'string', maxLength: 60, span: 8 },
            { campo: 'email', label: 'E-mail', tipo: 'string', maxLength: 150, span: 8 },
            { campo: 'site', label: 'Site', tipo: 'string', maxLength: 150, span: 8 },
            { campo: 'logradouro_tipo', label: 'Tipo de Logradouro', tipo: 'string', maxLength: 30, span: 6 },
            { campo: 'logradouro', label: 'Logradouro', tipo: 'string', maxLength: 200, span: 12 },
            { campo: 'numero', label: 'Número', tipo: 'string', maxLength: 20, span: 3 },
            { campo: 'complemento', label: 'Complemento', tipo: 'string', maxLength: 100, span: 3 },
            { campo: 'bairro', label: 'Bairro', tipo: 'string', maxLength: 100, span: 6 },
            { campo: 'cep', label: 'CEP', tipo: 'string', maxLength: 15, span: 4 },
            { campo: 'municipio', label: 'Município', tipo: 'string', maxLength: 100, span: 8 },
            { campo: 'uf', label: 'UF', tipo: 'string', maxLength: 2, span: 3 },
            { campo: 'cod_ibge', label: 'Cód. IBGE', tipo: 'string', maxLength: 10, span: 3 },
            { campo: 'telefone', label: 'Telefone', tipo: 'string', maxLength: 30, span: 6 },
            { campo: 'fax', label: 'Fax', tipo: 'string', maxLength: 30, span: 6 }
        ]
    })
}
</script>
